<template>
  <form @submit.prevent class="aoform" @call="active=true"  :class="{'active':active, 'locked': loading}" :disabled="loading?'disabled':false" id="accepting-orders-form" :reserve-scroll-bar-gap="true">
    <CloseBtn @click.native="active=false"/>
    <div class="aoform__content" ref="content">
      <div class="aoform__window" :style="shift">
        <div class="aoform__slides" >
          <Purchased v-if="order" :hideCondition="!order" :order="order" />
          <Step1 :hideCondition="step!=1 || serverError || (order != undefined)" />
          <Step2 :hideCondition="step!=2 || serverError || (order != undefined)" />
          <Step3 :hideCondition="step!=3 || serverError || (order != undefined)" />
        </div>
      </div>
    </div>
    <ErrorMessage v-if="serverError" />
    <PopupSample />
    <LoadingScreen v-model="loading" :active="active" />
  </form>
</template>

<script>
import LoadingScreen from '@/components/LoadingScreen.vue'
import CloseBtn from '@/components/CloseBtn.vue'
import ErrorMessage from '@/components/ErrorMessage.vue'
import Step1 from "@/components/Step1.vue"
import Step2 from '@/components/Step2.vue'
import Step3 from '@/components/Step3.vue'
import Purchased from '@/components/Purchased.vue'
import PopupSample from '@/components/PopupSample.vue'
import smoothHeight from 'vue-smooth-height'
import smoothscroll from 'smoothscroll-polyfill'

export default {
  components: { Step1, Step2, Step3, Purchased, ErrorMessage, CloseBtn, PopupSample, LoadingScreen },
  name: 'App',
  mixins: [smoothHeight],
  data: ()=>({
    active: false,
    scrollbarWidth: 0,
    scrollTimer: undefined,
    order: ''
  }),
  beforeMount(){
    this.order = new URLSearchParams(window.location.search).get('order')
    if (this.order)
      this.active = true
  },
  mounted(){
    this.$smoothElement({
      el: this.$refs.content,
      transition: 'height 1s'
    })
    smoothscroll.polyfill()
    this.scrollbarWidth = this.getScrollbarWidth() + 'px'
  },
  methods:{
    getScrollbarWidth() {
      const outer = document.createElement('div');
      outer.style.visibility = 'hidden';
      outer.style.overflow = 'scroll';
      outer.style.msOverflowStyle = 'scrollbar';
      document.body.appendChild(outer);
      const inner = document.createElement('div');
      outer.appendChild(inner);
      const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);
      outer.parentNode.removeChild(outer);
      return scrollbarWidth;
    },
    bodyLock() {
      document.body.classList.add('lock')
      document.documentElement.classList.add('lock')
    },
    bodyUnlock(){
      document.body.classList.remove('lock')
      document.documentElement.classList.remove('lock')
    }
  },
  watch: {
    active(val){
      clearTimeout(this.scrollTimer)
      if (val) {
          document.body.style.setProperty('max-width', `calc(100vw - ${this.scrollbarWidth})`)
          this.bodyLock()
        }
      else 
        this.scrollTimer = setTimeout(()=>{
          document.body.style.removeProperty('max-width')
          this.bodyUnlock()
          }, 150)
    },
  },
  computed:{
    step(){
      return this.$store.state.step
    },
    loading(){
      return this.$store.state.loading
    },
    serverError(){
      return this.$store.state.serverError
    },
    shift(){
      return `transform: translateX(${(1 - this.step) * 100}%)`
    }
  }
}
</script>

<style lang="sass">
body.lock, html.lock
  position: relative
  overflow: hidden
.aoform
  background: colors.$background
  position: fixed
  z-index: 50
  right: 0
  top: 0
  transition: transform .4s ease
  &:not(.active)
    transform: translateX(100%)
  &.active
    box-shadow: 0px 40px 32px rgba(0, 0, 0, 0.16)
    transform: translateX(0%)
  &.locked
    &, *
      pointer-events: none
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale
  color: colors.$font
  --formpadding: 80px
  --closebtn-height: 24px
  @include for-medium
    --formpadding: 40px
  @include from(breakpoints.$formMob)
    --formpadding: 24px
    --closebtn-height: 14px
  &, *
    font-family: fonts.$font
    box-sizing: border-box
  max-width: 100%
  width: 688px
  height: 100vh
  overflow-y: auto
  padding: var(--formpadding) 0
  &__content
    width: 100%
    overflow: hidden
  &__window
    width: 100%
    transition: transform .4s ease-out
  &__slides
    display: flex
    align-items: flex-start
    overflow: visible
    width: 100%
  &__step
    display: flex
    flex-direction: column
    width: 100%
    min-width: 100%
    min-height: calc(100vh - 2 * var(--formpadding) - var(--closebtn-height))
    padding: 0 var(--formpadding)
    transition: opacity .5s ease
    &_hidden
      opacity: 0
      pointer-events: none
      height: calc(100vh - 2 * var(--formpadding) - var(--closebtn-height)) !important
</style>
